export var WorkflowInputFieldTypeEnum;
(function (WorkflowInputFieldTypeEnum) {
    WorkflowInputFieldTypeEnum["STRING"] = "STRING";
    WorkflowInputFieldTypeEnum["EMAIL_TEMPLATE"] = "EMAIL_TEMPLATE";
    WorkflowInputFieldTypeEnum["SMS_TEMPLATE"] = "SMS_TEMPLATE";
    WorkflowInputFieldTypeEnum["PUSH_TEMPLATE"] = "PUSH_TEMPLATE";
    WorkflowInputFieldTypeEnum["PROMOTION"] = "PROMOTION";
})(WorkflowInputFieldTypeEnum || (WorkflowInputFieldTypeEnum = {}));
//# sourceMappingURL=WorkflowInputFieldTypeEnum.js.map